(() => {
  if (customElements.get('naninha-ring-simulator')) return;
  class NaninhaSimulator extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.pending = false;
      window.addEventListener('scroll', () => this.positionBeadBar(), { passive: true, signal: this.abort.signal });
      window.addEventListener('resize', () => this.positionBeadBar(), { passive: true, signal: this.abort.signal });
      window.addEventListener('message', event => this.receive(event), { signal: this.abort.signal });
      document.addEventListener('shopify:section:load', event => {
        if (event.target.querySelector('[data-naninha-catalogue]')) this.start();
      }, { signal: this.abort.signal });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.querySelector('[data-naninha-catalogue]')) setTimeout(() => this.start(), 0);
      }, { signal: this.abort.signal });
      document.addEventListener('shopify:section:reorder', () => this.start(), { signal: this.abort.signal });
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.start(), { once: true, signal: this.abort.signal });
      } else this.start();
    }
    disconnectedCallback() {
      this.abort?.abort();
    }
    start() {
      if (!this.isConnected || this.pending) return;
      const status = this.querySelector('[data-naninha-status]');
      try {
        const config = JSON.parse(this.querySelector('[data-naninha-config]').textContent);
        const variants = [55634171986255,55067188724047].map(id=>config.variants.find(v=>v.id===id));
        if(variants.some(v=>!v)||variants[1].price<=variants[0].price)throw Error('Les tarifs de cet anneau doivent être vérifiés.');
        const catalogue=[...document.querySelectorAll('[data-naninha-catalogue]')].flatMap(el=>JSON.parse(el.textContent));
        if(!catalogue.some(x=>x.available&&x.kind==='ribbon'&&x.color))throw Error('Ajoutez un ruban disponible.');
        if(!config.toys?.some(t=>t.available&&t.src))throw Error('Ajoutez un jouet en silicone disponible.');
        this.config = { ...config, variants, catalogue, origin: location.origin };
        this.frame?.remove();
        this.beadBar?.remove();
        this.beadChoice = null;
        const frame = document.createElement('iframe');
        frame.title = 'Personnalisation de votre anneau de dentition';
        frame.style.cssText = 'display:block;width:100%;height:540px;border:1px solid #e4dcd2;border-radius:18px;background:#fffaf5;overflow-anchor:none';
        frame.setAttribute('scrolling', 'no');
        frame.setAttribute('allow', 'web-share');
        const safeJSON = JSON.stringify(this.config).replace(/</g, '\\u003c');
        const safeAttribute = value => String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
        frame.srcdoc = `<!doctype html><html lang="fr" data-theme="light"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><link rel="stylesheet" href="${safeAttribute(config.css)}"></head><body>${this.querySelector('[data-naninha-body]').innerHTML}<script>window.NANINHA_CONFIG=${safeJSON};<\/script><script src="${safeAttribute(config.engine)}"><\/script></body></html>`;
        this.frame = frame;
        this.appendChild(frame);
        const bar = document.createElement('div');
        bar.hidden = true;
        bar.style.cssText = 'position:fixed;z-index:50;box-sizing:border-box;display:none;gap:8px;align-items:center;padding:10px 12px;border:1px solid #d8c5ac;border-radius:14px;background:#fffaf5;box-shadow:0 4px 24px #3f2b1729;color:#312922;font:14px/1.3 system-ui,sans-serif';
        const label = document.createElement('div');
        label.style.cssText = 'flex:1;min-width:0;overflow-wrap:anywhere';
        const name = document.createElement('div');
        const status = document.createElement('div');
        status.setAttribute('aria-live', 'polite');
        status.style.cssText = 'font-size:12px;margin-top:3px;color:#705a40';
        label.append(name, status);
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = 'Ajouter cette perle';
        button.style.cssText = 'flex:0 0 auto;max-width:48%;min-height:48px;padding:9px 14px;border:0;border-radius:10px;background:#b89468;color:white;font:600 14px/1.3 system-ui,sans-serif;cursor:pointer';
        button.onclick = () => {
          if (!this.beadChoice?.active || button.disabled || this.pending) return;
          this.frame.contentWindow.postMessage({source:'naninha-boutique',type:'add-bead'}, this.config.origin);
        };
        bar.append(label, button);
        this.beadBar = bar;
        this.beadName = name;
        this.beadStatus = status;
        this.beadButton = button;
        this.appendChild(bar);
        status.hidden = true;
      } catch (error) {
        status.hidden = false;
        status.textContent = error.message || 'Le simulateur n’a pas pu être chargé. Rechargez la page.';
      }
    }
    positionBeadBar() {
      if (!this.beadBar || !this.frame) return;
      const rect = this.frame.getBoundingClientRect();
      const visible = this.beadChoice?.active && rect.top < innerHeight - 120 && rect.bottom > 140;
      this.beadBar.hidden = !visible;
      this.beadBar.style.display = visible ? 'flex' : 'none';
      if (!visible) return;
      this.beadBar.style.left = `${Math.max(8, rect.left + 8)}px`;
      this.beadBar.style.width = `${Math.min(rect.width - 16, innerWidth - 16)}px`;
      this.beadBar.style.bottom = `${Math.max(12, innerHeight - rect.bottom + 12)}px`;
    }
    async receive(event) {
      if (event.source !== this.frame?.contentWindow || event.origin !== location.origin || event.data?.source !== 'naninha-simulateur') return;
      const data = event.data;
      if (data.type === 'bead-choice') {
        this.beadChoice = data;
        this.beadName.textContent = data.label || 'Choisissez une perle';
        this.beadStatus.textContent = data.status || '';
        this.beadButton.disabled = !!data.disabled;
        this.beadButton.style.opacity = data.disabled ? '.5' : '1';
        this.positionBeadBar();
        return;
      }
      if(data.type==='step'&&Number.isFinite(data.height)&&Number.isFinite(data.anchor)){
        const frameTop=window.scrollY+this.frame.getBoundingClientRect().top;
        this.frame.style.height=`${Math.max(260,Math.min(5000,data.height))}px`;
        const anchor=Math.max(0,Math.min(data.height,data.anchor)),token=this.navigationToken=(this.navigationToken||0)+1;
        requestAnimationFrame(()=>requestAnimationFrame(()=>{
          if(token!==this.navigationToken||!this.isConnected)return;
          const header=document.querySelector('#header-component'),headerRect=header?.getBoundingClientRect();
          const sticky=header?.getAttribute('sticky');
          const headerSpace=headerRect&&(['always','scroll-up'].includes(sticky)||headerRect.top<=1&&headerRect.bottom>0)?headerRect.height:0;
          const top=Math.max(0,frameTop+anchor-headerSpace-12);
          window.scrollTo({top,behavior:'instant'});this.positionBeadBar();
        }));
        return;
      }
      if (data.type === 'height' && Number.isFinite(data.height)) {
        this.frame.style.height = `${Math.max(260, Math.min(5000, data.height))}px`;
        this.positionBeadBar();
        return;
      }
      if (data.type !== 'order' || this.pending) return;
      this.pending = true;
      try {
        if (this.config.editor) throw Error('Pour tester l’ajout au panier, ouvrez Aperçu dans un nouvel onglet.');
        if (!Array.isArray(data.beads) || !data.beads.length || data.beads.length > 110) throw Error('La composition est incomplète.');
        const available = new Map(this.config.catalogue.filter(x => x.available).map(x => [x.id, x]));
        const sizes = { r12: 12, r15: 15, lens: 7, flat: 2, hex: 15, cotton: 15, cube: 10 };
        let total = 0;
        for (const bead of data.beads) {
          if (typeof bead.name !== 'string' || bead.name.length > 240) throw Error('Une perle de la composition est invalide.');
          if (bead.fantasy) {
            const record = available.get(bead.type);
            if (!record || record.kind !== 'fancy') throw Error('Une perle sélectionnée n’est plus disponible.');
            total += Number(record.length);
          } else {
            if (!(bead.type in sizes)) throw Error('Une forme de perle est invalide.');
            total += sizes[bead.type];
          }
        }
        const fancyCount = data.beads.filter(b => b.fantasy).length;
        const selectedToy=this.config.toys.find(t=>t.id===data.toyId&&t.available&&t.src);
        if(!selectedToy)throw Error('Choisissez un jouet disponible.');
        const letters=data.beads.map((b,i)=>b.type==='cube'?i:-1).filter(i=>i>=0);
        for(let j=1;j<letters.length;j++){if(letters[j]!==letters[j-1]+2||data.beads[letters[j]-1].type!=='lens')throw Error('Une lentille est obligatoire entre chaque lettre.');}
        if (![0,1].includes(fancyCount) || !Number.isFinite(total) || total > (this.config.maxMm||203)) throw Error('Vérifiez le nombre de fantaisies et la longueur de votre composition.');
        const variant = this.config.variants[fancyCount];
        if (!variant.available) throw Error('Cette option est actuellement indisponible.');
        const properties = {
          'Modèle': 'Anneau de dentition',
          'Jouet de dentition': selectedToy.name,
          'Ruban': String(data.ribbon).slice(0, 100),
          'Prénom': data.beads.map(b => b.letter || '').join(''),
          'Nombre de fantaisies': String(fancyCount),
          'Longueur des perles': `${(total / 10).toFixed(1).replace('.', ',')} cm`,
          'Sens de lecture': 'Prénom de gauche à droite, puis autour de l’anneau',
          '_naninha': '1'
        };
        data.beads.forEach((bead, i) => { properties[`Perle ${String(i + 1).padStart(2, '0')}`] = bead.name; });
        if (!(data.preview instanceof Blob) || data.preview.type !== 'image/png' || data.preview.size > 10 * 1024 * 1024) throw Error('L’aperçu de la création est invalide.');
        const body = new FormData();
        body.append('id', String(variant.id));
        body.append('quantity', '1');
        Object.entries(properties).forEach(([key, value]) => body.append(`properties[${key}]`, value));
        body.append('properties[_naninha_apercu]', data.preview, 'anneau-de-dentition.png');
        const response = await fetch(this.config.cartAdd, {
          method: 'POST', credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body
        });
        const result = await response.json();
        if (!response.ok || result.status) throw Error(result.description || result.message || 'L’ajout au panier n’a pas abouti.');
        location.assign(this.config.cartUrl);
      } catch (error) {
        this.pending = false;
        this.frame.contentWindow.postMessage({ source: 'naninha-boutique', type: 'error', message: error.message || 'L’ajout au panier n’a pas abouti. Veuillez réessayer.' }, location.origin);
      }
    }
  }
  customElements.define('naninha-ring-simulator', NaninhaSimulator);
})();


